import { Sidebar, Footer } from "../components/utils";
import { useSidebarStore } from "../hooks";

export const DoctorLayout = (props) => {
  const {
    // Props
    toggle,
  } = useSidebarStore();

  return (
    <div
      className={`${toggle ? "" : "toggled-doctor"} page-wrapper doctris-theme`}
    >
      <Sidebar manuClass="sidebar-wrapper doctor sidebar-dark" />
      <main className="page-content doctor bg-light">
        <div className="container-fluid">
          <div className="layout-without-header">{props.children}</div>
        </div>
        <Footer />
      </main>
    </div>
  );
};
